const getCanonicalPath = (article, market) => {
  // Handle Black Friday 2019 featured article.
  // It is an article merged from several articles so
  // canonicals for merged articles should point on campaign page
  if (article.related.campaign && article.related.campaign.id === 2) {
    if (market.code === 'se' && [43, 169, 177].includes(article.id)) {
      return article.related.campaign.web_uri.responsive;
    }

    if (market.code === 'no' && [51, 55, 54].includes(article.id)) {
      return article.related.campaign.web_uri.responsive;
    }

    if (market.code === 'gb' && [85, 84, 69].includes(article.id)) {
      return article.related.campaign.web_uri.responsive;
    }

    if (market.code === 'fi' && [20, 17].includes(article.id)) {
      return article.related.campaign.web_uri.responsive;
    }
  }

  if (article.related.campaign && article.featured) {
    // Use campaign page as canonical if article is featured
    return article.related.campaign.web_uri.responsive;
  }
  if (article.related.category && article.featured) {
    // Use category page as canonical if article is featured
    return article.related.category.pathName;
  }
  return article.pathName;
};

export default ({ data }, { market, t }) => {
  if (!data) {
    return {};
  }

  const { article } = data;

  if (!article) {
    return {};
  }

  const canonicalUrl = market.domain + getCanonicalPath(article, market);
  const articleUrl = market.domain + article.pathName;
  const openGraph = [
    { key: 'title', content: article.title },
    { key: 'type', content: 'article' },
    { key: 'url', content: articleUrl },
    { key: 'image', content: article.imageUrl },
  ];

  return {
    title: t('meta', 'article.page-title', { title: article.title }),
    description: article.preamble,
    canonical: canonicalUrl,
    structuredData: undefined,
    openGraph,
    // We only support hreflang tags on campaign articles for now
    hrefLang: article.related.campaign ? article.hrefLang : [],
  };
};
